import { render, staticRenderFns } from "./pageBread.vue?vue&type=template&id=2c7d52da&scoped=true"
import script from "./pageBread.vue?vue&type=script&lang=js"
export * from "./pageBread.vue?vue&type=script&lang=js"
import style0 from "./pageBread.vue?vue&type=style&index=0&id=2c7d52da&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/mobile/bread.less?vue&type=style&index=1&id=2c7d52da&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7d52da",
  null
  
)

export default component.exports